// extracted by mini-css-extract-plugin
module.exports = {"isActive":"LinkComponent-styles-module--isActive--1j2gA"};